import React from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { CollegeList } from './CollegeList'

const StudentCollegeList = () => {
	const { studentId } = useParams()
	const { user } = useAuth()
	const isInstructorView = user?.role === 'Instructor'
	const effectiveStudentId = isInstructorView ? studentId : user?.id

	return (
		<StudentTopMenuLayout activeMenu="CollegeList" pageName="CollegeList">
			<CollegeList studentId={effectiveStudentId} />
		</StudentTopMenuLayout>
	)
}

export { StudentCollegeList }
